module.exports = __webpack_public_path__ + "media/images/checkout/challenger/phone_mobile-80ad6cece420d90c717a5f928009c8d9.svg";